<!-- Hero -->
<div class="dashboard-hero">
  <div class="hero-content d-flex align-items-center justify-content-between flex-wrap gap-3">
    <div>
      <h1 class="hero-title">
        <i class="bi bi-file-earmark-image hero-icon"></i> DXF to JPG Converter
      </h1>
      <p class="hero-subtitle">Convert DXF files to JPG images instantly.</p>
    </div>
    <button class="btn btn-hero-action" routerLink="/articles">
      <i class="bi bi-upload"></i>
      <span>Article Staging</span>
    </button>
  </div>
</div>

<div class="container dashboard-container">

  <!-- Error -->
  <div class="alert alert-warning alert-dismissible" role="alert" *ngIf="displayError">
    <i class="bi bi-exclamation-triangle-fill me-2"></i>{{ errorMessage }}
  </div>

  <!-- Upload Card -->
  <div class="modern-card mb-4" *ngIf="!hasFile">
    <div class="modern-card-header">
      <div class="card-title-wrapper">
        <i class="bi bi-cloud-upload card-icon"></i>
        <h5 class="modern-card-title">Upload a DXF File</h5>
      </div>
    </div>
    <div class="modern-card-body">
      <div class="upload-drop-zone">
        <i class="bi bi-file-earmark-arrow-up upload-drop-icon"></i>
        <p class="upload-drop-label">Select a DXF file to convert to JPG</p>
        <label for="inputGroupFile" class="btn-modern-action btn-action-primary upload-btn">
          <i class="bi bi-folder2-open"></i> Choose DXF File
        </label>
        <input type="file" name="dxfFile" id="inputGroupFile" class="d-none" required
          (change)="handleDxfUpload($event)"
          accept=".dxf, image/vnd.dxf" />
        <p class="upload-hint">Accepted format: <strong>.dxf</strong></p>
      </div>
    </div>
  </div>

  <!-- Preview Card -->
  <div class="modern-card mb-4" *ngIf="hasFile && jpgUrl">
    <div class="modern-card-header">
      <div class="card-title-wrapper">
        <i class="bi bi-image card-icon"></i>
        <h5 class="modern-card-title">JPG Preview</h5>
      </div>
      <div class="header-actions">
        <a [href]="jpgUrl" download="converted.jpg" class="btn-modern-action btn-action-primary">
          <i class="bi bi-download"></i> Download JPG
        </a>
      </div>
    </div>
    <div class="modern-card-body preview-body">
      <img [src]="jpgUrl" alt="JPG Preview" class="img-fluid preview-img" />
    </div>
  </div>

</div>

<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>